import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import CruisePriceRoomTypeInfo from './CruisePriceRoomTypeInfo'
import OfferPageStickyFooter from 'components/OfferPage/OfferPageStickyFooter'
import { CruiseContentSections } from 'constants/cruise'
import Group from 'components/utils/Group'

interface Props {
  onView: (ref: string) => void
  offer: App.CruiseOffer
  priceFrom: App.CruisePriceDetails
  hasValidDepartures?: boolean
  visible: boolean
}

function CruiseStickyFooter(props: Props) {
  const intl = useIntl()
  const { onView, priceFrom, visible, hasValidDepartures, offer } = props

  const onCTAClick = useCallback(() => onView(CruiseContentSections.DEPARTURES), [onView])

  return (
    <OfferPageStickyFooter
      visible={visible}
      callToActionCopy={intl.formatMessage({
        id: 'Xd/zizMcQ1',
        defaultMessage: 'Check Availability',
        description: 'Button label to check cruise availability in the cruise section',
      })}
      onCTAClick={onCTAClick}
      callToActionDisabled={!hasValidDepartures}
    >
      <Group direction="horizontal" verticalAlign="center" horizontalAlign="space-between" tabletGap={16}>
        <CruisePriceRoomTypeInfo priceFrom={priceFrom} hasValidDepartures={hasValidDepartures} offer={offer} />
      </Group>
    </OfferPageStickyFooter>
  )
}
export default CruiseStickyFooter
